e.L = e.Library = {
	init : function(){
		e.L.icons.init();
	}
};
